import { put, takeEvery, call } from "redux-saga/effects";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import endpoints from "../endpoints";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* commonPendingBillFunction(value) {
  const token = localStorage.getItem("fmsToken");
  const authorization =
    // appConfig.env !== "production"
    //   ? "Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJCaWxsaW5nU2VydmljZSIsIm5hbWUiOiJTbWFydGVyIEhvbWVzIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.pn9ejLRPhMr9f_foDP-zVbFWZqEI2r2vXLU9uFSumDCxExY4J7O_ROwUt0fv6OKg8J-aGUPDjexB6a_71ur9LQ"
    //   :
    `Bearer ${token}`;
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authorization,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* commonPostFunction(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield put({
        type: `${value.initAction}`,
      });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status400}`);
      } else if (err.status === 500) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status500}`);
      } else {
      }
    }
  }
}

function* fetchApartments(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Total",
    type: "All",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
      method: "POST",
      sucessAction: actionTypes.FETCH_APARTMENTS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_APARTMENTS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchCurrentAlerts() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    type: "current",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/alert`,
      method: "POST",
      sucessAction: actionTypes.FETCH_CURRENT_ALERTS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_CURRENT_ALERTS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchSocietyConsumption(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let startDate = params?.params?.start;
  let endDate = params?.params?.end;
  const data = {
    societyId: societyId,
    startdate: startDate,
    enddate: endDate,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/watersourceservice/society/consumptionsummary`,
      method: "POST",
      sucessAction: actionTypes.FETCH_SOCOETY_CONSUMPTION_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_SOCOETY_CONSUMPTION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchPendingBills() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/pendingbill`,
      method: "POST",
      sucessAction: actionTypes.FETCH_PENDING_BILL_APARTMENT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_PENDING_BILL_APARTMENT_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonPendingBillFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchBillDetails() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/societydataservice/society/getcollectiondetails`,
      method: "POST",
      sucessAction: actionTypes.FETCH_BILL_DETAILS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_BILL_DETAILS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchTotalCommercialWater(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let month = params?.params?.month;
  let year = params?.params?.year;
  let type = params?.params?.type;
  const data = {
    society: societyId,
    source: type,
    month: month,
    year: year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
      method: "POST",
      sucessAction: actionTypes.FETCH_COMMERCIAL_WATER_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_COMMERCIAL_WATER_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}
function* fetchTotalMunicipalWater(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let month = params?.params?.month;
  let year = params?.params?.year;
  let type = params?.params?.type;
  const data = {
    society: societyId,
    source: type,
    month: month,
    year: year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
      method: "POST",
      sucessAction: actionTypes.FETCH_MUNICIPAL_WATER_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_MUNICIPAL_WATER_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchTotalGroundWater(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let month = params?.params?.month;
  let year = params?.params?.year;
  let type = params?.params?.type;
  const data = {
    society: societyId,
    source: type,
    month: month,
    year: year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
      method: "POST",
      sucessAction: actionTypes.FETCH_GROUND_WATER_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_GROUND_WATER_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchTotalRainWater(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let month = params?.params?.month;
  let year = params?.params?.year;
  let type = params?.params?.type;
  const data = {
    society: societyId,
    source: type,
    month: month,
    year: year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
      method: "POST",
      sucessAction: actionTypes.FETCH_RAIN_WATER_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_SLAB_RATE_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);

    return Res;
  } catch (e) {}
}

function* fetchSlabRateTotal(params) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getslabrate`,
      method: "POST",
      sucessAction: actionTypes.FETCH_SLAB_RATE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_SLAB_RATE_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

function* addPrimaryRwaMember(values) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let data = {
    societyId: societyId,
    members: values.value,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/insertrwamembers`,
      method: "POST",
      sucessAction: actionTypes.ADD_PRIMARY_RWAMEMBER_SUCCESS_ACTION,
      toastMsg: "RWA Member added successfully",
      failAction: actionTypes.ADD_PRIMARY_RWAMEMBER_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonPostFunction, params);
    if (Res.status.toLowerCase() == "success") {
      localStorage.setItem("rwastatus", true);
    }

    return Res;
  } catch (e) {}
}

function* fetchAggregateConsumption(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    month: value?.value?.month,
    year: value?.value?.year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/watersourceservice/society/aggregateconsumption`,
      method: "POST",
      sucessAction: actionTypes.FETCH_AGGREGATE_CONSUMPTION_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_AGGREGATE_CONSUMPTION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.dashboardGetFunction, params);
    return Res;
  } catch (e) {}
}

export function* dashboardActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_CURRENT_ALERTS_INIT_ACTION,
    fetchCurrentAlerts
  );
  yield takeEvery(actionTypes.FETCH_APARTMENTS_INIT_ACTION, fetchApartments);
  yield takeEvery(
    actionTypes.FETCH_SOCOETY_CONSUMPTION_INIT_ACTION,
    fetchSocietyConsumption
  );
  yield takeEvery(
    actionTypes.FETCH_PENDING_BILL_APARTMENT_INIT_ACTION,
    fetchPendingBills
  );
  yield takeEvery(actionTypes.FETCH_BILL_DETAILS_INIT_ACTION, fetchBillDetails);
  yield takeEvery(
    actionTypes.FETCH_COMMERCIAL_WATER_INIT_ACTION,
    fetchTotalCommercialWater
  );
  yield takeEvery(
    actionTypes.FETCH_MUNICIPAL_WATER_INIT_ACTION,
    fetchTotalMunicipalWater
  );
  yield takeEvery(
    actionTypes.FETCH_GROUND_WATER_INIT_ACTION,
    fetchTotalGroundWater
  );
  yield takeEvery(
    actionTypes.FETCH_RAIN_WATER_INIT_ACTION,
    fetchTotalRainWater
  );
  yield takeEvery(actionTypes.FETCH_SLAB_RATE_INIT_ACTION, fetchSlabRateTotal);
  yield takeEvery(
    actionTypes.ADD_PRIMARY_RWAMEMBER_INIT_ACTION,
    addPrimaryRwaMember
  );
  yield takeEvery(
    actionTypes.FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION,
    fetchAggregateConsumption
  );
}
